import sectionsRef from "@models/interactions/sections-ref";
import LegalLayout from "@components/templates/legal-layout";


export default function Contest() {
  const { model, operations } = sectionsRef(23);

  return (
    <LegalLayout>
      <main className="w-full flex flex-col text-white px-4 max-w-[1010px] mt-[60px]">
        <h2 className=" text-white text-center font-semibold text-4xl">Terms of Service</h2>
        <span className=" text-white text-center mt-4">WELCOME TO MEMO’D!
          <article className=" text-white text-left mt-4">
            PLEASE READ THE FOLLOWING TERMS OF SERVICE CAREFULLY.
            BY ACCESSING OR USING OUR SERVICES,
            YOU HEREBY ACCEPT AND AGREE TO BE BOUND BY THESE TERMS AND ALL TERMS INCORPORATED HEREIN BY REFERENCE.
            IT IS THE RESPONSIBILITY OF YOU, THE USER OR MEMBER,
            TO READ THE TERMS OF SERVICE BEFORE PROCEEDING TO USE ANY OF OUR SERVICES,
            INCLUDING BUT NOT LIMITED TO ALL FEATURES, SITES, AND CONTENT.
          </article>
        </span>
        <div className="flex flex-col text-white mt-4 text-xl">
          <span>
            1.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[0]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Acceptance of Terms
            </a>
          </span>
          <span>
            2.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[1]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Definitions
            </a>
          </span>
          <span>
            3.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[2]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Description of Memo’d Services
            </a>
          </span>
          <span>
            4.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[3]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Access and Use of Services
            </a>
          </span>
          <span>
            5.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[4]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Intellectual Property; Propietary Rights
            </a>
          </span>
          <span>
            6.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[5]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              User Content
            </a>
          </span>
          <span>
            7.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[6]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Copyright Policy
            </a>
          </span>
          <span>
            8.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[7]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Privacy Policy
            </a>
          </span>
          <span>
            9.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[8]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Account, Username, Password and Security
            </a>
          </span>
          <span>
            10.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[9]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Use and Storage General Practices
            </a>
          </span>
          <span>
            11.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[10]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Cancellation; Termination
            </a>
          </span>
          <span>
            12.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[11]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Links
            </a>
          </span>
          <span>
            13.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[12]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Indemnity
            </a>
          </span>
          <span>
            14.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[13]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Warranty Disclaimers
            </a>
          </span>
          <span>
            15.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[14]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Limitation of Liability
            </a>
          </span>
          <span>
            16.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[15]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Exclusions and Limitations
            </a>
          </span>
          <span>
            17.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[16]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Release
            </a>
          </span>
          <span>
            18.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[17]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Special Admonition Related to Financial Matters
            </a>
          </span>
          <span>
            19.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[18]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Third Party Beneficiaries
            </a>
          </span>
          <span>
            20.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[19]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Notice
            </a>
          </span>
          <span>
            21.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[20]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Dispute Resolution
            </a>
          </span>
          <span>
            22.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[21]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Statute of Limitations
            </a>
          </span>
          <span>
            23.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[22]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              General Information
            </a>
          </span>
        </div>

        <article className="flex w-full flex-col justify-start gap-[18px] lg:w-[916px] text-white mt-4">
          <section ref={model.refs[0]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px] ml-8">
              <strong className="text-xl">1. ACCEPTANCE OF TERMS</strong>
              <p className="ml-3">The following Terms of Service is a legally binding agreement which governs Your
                 use of our Services.</p>
              </span>
          </section>
          <section ref={model.refs[1]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px]  ml-8">
              <strong className="text-xl">2. DEFINITIONS</strong>
                <p className="ml-3">2.1 “AAA” has the meaning set forth in Section 21.2.</p>
                <p className="ml-3">2.2 “AAA Rules” has the meaning set forth in Section 21.2.</p>
                <p className="ml-3">2.3 “Agreement” or “Terms of Service” means these terms of service, and all terms incorporated herein by reference,
                   which governs Memo’d’s relationship with its Users and Members.</p>
                <p className="ml-3">2.4 “App” means Memo’d’s mobile application(s) for the Services,
                   which Users may download for the iOS operating system.</p>
                <p className="ml-3">2.5 “Book Insights” has the meaning set forth in Section 3.1.1.</p>
                <p className="ml-3">2.6 “Content” has the meaning set forth in Section 3.1.1.</p>
                <p className="ml-3">2.7 “Content Library” means the Content designated by Memo’d, such as Book Insights or Memos,
                   to be made available to Members and Users.  At its discretion, Memo’d may update, add, remove,
                    rotate, modify,
                    or revise any Content in the library.</p>
                <p className="ml-3">
                2.8 “Content Provider” and “Creator” shall mean any author, writer, contributor,
                 or other provider whose Content exists in the Content Library.
                </p>
                <p className="ml-3">
                2.9 “Member” means any User who has signed up for or purchased any of the Services.
                </p>
                <p className="ml-3">
                2.10 “Memo’d”, “our”, “us”, or “we” means Memo’d Technologies, LLC.
                </p>
                <p className="ml-3">
                2.11 “Memos” has the meaning set forth in Section 3.1.3.
                </p>
                <p className="ml-3">
                2.12 "Payment Method" means a current, valid, accepted method of payment,
                 as may be updated from time to time and which may include payment through Your account with a third party.
                </p>
                <p className="ml-3">
                2.13 “Service” and “Services” shall mean the collective services provided by Memo’d,
                 including but not limited to a subscription to the Content Library or other Content on the Service;
                  any products, features, tools, materials, or other services offered from time to time by Memo’d through the App,
                  Site, or other platforms; any essential software that may be used in connection with such services; and all other elements of the App,
                  Site, and other Memo’d platforms (including source code and object code).
                </p>
                <p className="ml-3">
                2.14 “Site” means the Memo’d website (<a className="text-blue-700 hover:underline" href="https://memod.com">https://memod.com</a>). 
                </p>
                <p className="ml-3">
                2.15 “Subscription Plan” means any membership plan that deems a User
                 as a Member or grants a Member access to an exclusive content offering, and whereby we,
                  along with all participating Content Providers, grant You a nonexclusive, nontransferable,
                   revocable and limited personal license to access the Content Library or other Content on the Service.
                </p>
                <p className="ml-3">
                2.16 “User” means any visitor or user of the Services. 
                </p>
                <p className="ml-3">
                2.17 “User Content” and “Posted Content” has the meaning set forth in Section 6.1.
                </p>
                <p className="ml-3">
                2.18 “You,” “Your,” or “Yourself” means you as a User or Member.   
                </p>
            </span>
          </section>
          <section ref={model.refs[2]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px]  ml-8">
              <strong className="text-xl">3. DESCRIPTION OF MEMO’D SERVICES</strong>
              <p className="ml-3">3.1  <strong className="underline">Memo’d Services.</strong>  Memo’d is an information and reading platform built on the idea 
              that the time spent on everyday tasks can be transformed into opportunities to learn, be entertained,
              and stay informed.  With robust content management and writing features, Memo’d Services offers a
              comprehensive catalog of original content.</p>
              <p className="ml-3">3.1.1 <strong className="underline">Content.</strong>  “Content” on the Service includes writings, audio, graphics, photos,
              text (such as comments), branding (including trade names, trademarks, service marks, or logos),
              interactive features, software, metrics, and other materials provided by You, Memo’d, or a third-party.
              Content is the responsibility of the person or entity that provides it to the Service,
                and Memo’d is under no obligation to host or serve Content (see “User Content” below).</p>
              <p className="ml-3">3.1.2 <strong className="underline">Book Insights.</strong>  “Book Insights” are explorations of bestselling nonfiction books that can
              be read or listened to in just 30 minutes.  Book Insights are written by a team comprised of
              published authors and professional writers.  Each Book Insight imparts the main themes,
              key ideas, and useful takeaways from the underlying book.  Book Insights may feature
              author history and audio clips, criticisms of the book, and in-depth analysis. Additionally,
              Book Insights may be adapted into videos or other content formats.</p>
              <p className="ml-3">3.1.3  <strong className="underline">Memos.</strong> “Memos” are bulleted writings that may be read in a few minutes. Memos are written
              by published authors, professional writers, and Users. Memos may be synopses of external sources or
              original ideas (see “User Content” below).</p>
              <p className="ml-3">3.2  <strong className="underline">Content Library.</strong>  Depending on whether You are a Member or a User with a Memo’d or free Book 
              Insights account, You may have access to different portions of the Content Library. </p>
              <p className="ml-3">3.3  <strong className="underline">Subscription Plan.</strong>  As part of our Services, we may offer one or more Subscription Plans.
              If You sign up for a Subscription Plan, You agree to the terms, conditions, and limitations associated
              with such plans, which will be disclosed to You through the App, Site, or other communications made available to You.
              The existence and features of any Subscription Plan offered by Memo’d may change from time to time. 
              If you purchase a Subscription Plan, your Memo’d membership to such plan may be one-time or will continue month-to-month
              or year-to-year, as specified in the terms for such plan, and may automatically renew until terminated.
              If your Subscription Plan is subject to automatically renew, You must cancel your membership to a 
              Subscription Plan before it renews for the next subscription period in order to avoid billing of the next period’s
              Subscription Plan fees to your Payment Method (see "Cancellation" below).
              Purchase of a Subscription Plan does not constitute any ownership of the Content (see "Ownership" below)
              and is subject to all terms herein, including but not limited to Service and Content Availability provisions
              (see "Service and Content Availability" below).</p>
              <p className="ml-3">3.4  <strong className="underline">Free Trials.</strong>  We may offer Users and certain Members a free trial to a Subscription Plan.
              The specific terms of any applicable free trial will be stated in the materials describing the
              particular free trial or during Your sign-up for the free trial.  Free trial eligibility is
               determined by Memo’d at its sole discretion and we may limit eligibility or duration to prevent
              free trial abuse. We reserve the right to revoke any free trial and put Your account on hold in
               the event that we determine that You are not eligible.</p>
              <p className="ml-3">3.5  <strong className="underline">Service and Content Availability.</strong>  At its discretion, Memo’d may offer additional Services or update,
              modify or revise any current Services, and this Agreement shall apply to any and all additional,
              updated, modified, or revised Services unless otherwise stipulated.  In addition, we continually
              test various aspects of our Services, including but not limited to, the Site, Apps, user interfaces,
              promotional features, and availability of our content.  Memo’d may update, add, remove, rotate, modify,
              or revise any content in the Content Library.  Memo’d reserves the right to discontinue or cease offering
              any of the aforementioned Services and/or Content,
              whether temporarily or permanently, in whole or in part thereof.  These changes may affect the availability
              or accessibility of certain Content in the Content Library,
              including titles which a Member may have previously accessed.  You, acknowledge, accept, and agree that Memo’d
              shall not be held liable for any such updates, modifications, revisions, suspensions or discontinuance of any
              of our Services and/or Content. </p>
            </span>
          </section>
          <section ref={model.refs[3]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px]  ml-8">
              <strong className="text-xl">4. ACCESS AND USE OF SERVICES.</strong>
              <p className="ml-3">4.1  <strong className="underline">Ownership.</strong>  You acknowledge and agree that Memo’d owns and retains all rights
              to the Services and the Content available through the Services.  Any Services and any 
              Content available through the Services, such as trademarks, trade names, service marks,
              brand features, text, graphics, logos, button icons, images, audio clips, digital downloads,
              data compilations, and software (source code and object code), is the property of Memo’d or 
              its Content Providers and protected by United States and international copyright, trademark,
              and other applicable intellectual property laws. </p>
          
           
              <p className="ml-3">4.2  <strong className="underline">Services Provided on “As-Is” Basis.</strong>  You understand,
              acknowledge and agree that the Services offered shall be provided on an “AS IS” and “AS AVAILABLE” basis,
              and as such, Memo’d shall not assume any responsibility or obligation for the timeliness,
              missed delivery, deletion, and/or any failure to store Content, communication,
              or personalization settings.</p>

              <p className="ml-3">4.3  <strong className="underline">Restriction on Use.</strong>  You may not sell, distribute,
              or display any Memo’d Content outside of direct personal use.
              You agree not to display and/or use in any manner the Memo’d logo or marks without Memo’d’s prior written consent.
              You may not transfer, share, or lend your Subscription Plan or any Memo’d Content for commercial or public use.
              You agree not to replicate, duplicate, copy, trade, sell, resell or exploit for any commercial reason any part,
              use of, or access to the Services, including the Site, the Apps, the Content Library,
              and Content on the Service.  Furthermore, unauthorized reproduction, publication, distribution,
              or exhibition of any information or materials supplied by our Services,
              despite whether done so in whole or in part, is expressly prohibited.</p>

              <p className="ml-3">4.4  <strong className="underline">Conduct.</strong>  Memo’d reserves the right to include the use of security components that may permit
              digital information or material to be protected, and that such use of information and/or material
              is subject to usage guidelines and regulations established by Memo’d or any other Content Providers.
              You are hereby prohibited from making any attempt to override or circumvent any of the embedded
              usage rules in our Services. </p>

              <p className="ml-3">4.5  <strong className="underline">Registration.</strong>  When You voluntarily register with us, You acknowledge, understand,
              and agree to furnish factual, correct, current and complete information with regards to Yourself
              as may be requested by the data registration process, and maintain and promptly update Your
              registration and profile information in an effort to maintain accuracy and completeness at all
              times.  If You knowingly provide any information of a false, untrue, inaccurate,
              or incomplete nature, Memo’d will have sufficient grounds and rights to suspend or terminate
              Your account, and as such, refuse any and all current or future use of Memo’d Services,
              or any portion thereof. </p>

              <p className="ml-3">4.6  <strong className="underline">Age Limitations. </strong>In order to register for our Services, You must be at least 13 years of age 
              (or the applicable age of majority in Your state, province, territory, or country of residence), 
              and able to enter into and form a legally binding contract. In addition, You must be in good standing
              and not an individual or entity that has been previously barred from receiving Memo’d’s Services
              under the laws and statutes of the United States or other applicable jurisdiction.</p>
              
              <p className="ml-3">It is Memo’d’s priority to ensure the safety and privacy of its Users and Members,
              especially that of minors.  If You are under 18 years of age (or the applicable age of majority
              in Your state, province, territory, or country of residence), You represent that You have Your
              parent or guardian’s permission to utilize the Services.  Please have them read these Terms with You.
              If You, as a parent or legal guardian of any person under the age of 18, permit such person access
              to the Services, You are subject to these Terms and responsible for your child’s activity.
              It is Your responsibility to determine whether any of the Services and the content accessible
              through such Services are age-appropriate for such person.</p>

              <p className="ml-3">4.7  <strong className="underline">Business.</strong>If you are registering or using our Services on behalf of any company or organization,
              you represent that you have authority to act on behalf of that entity, and that such entity accepts
              these Terms and all Terms herein by reference.</p>

              <p className="ml-3">4.8  <strong className="underline">Collection of Information. </strong>As described in this Agreement, we may collect personal information directly and voluntarily
              from You as well as through Your use of the Services. Collection of this information is intended
              to assist Memo’d in providing Services.  When You voluntarily register with us, Memo’d may collect
              information such as Your name, e-mail address, birth date, gender, mailing address, occupation,
              industry and personal interests.  You can edit Your account information at any time.</p>

              <p className="ml-3">As a User or Member, You herein consent to the collection and use of the information provided,
              including the transfer of information within the United States and/or other countries for storage,
              processing, or use by Memo’d and/or our subsidiaries and affiliates. The non-identifying
              information we collect or store is also used to improve the content of our Services and
              to help us understand how people are using our Services. This information does not identify
              You personally and is used for gathering product usage and Content consumption statistics.
              The information we automatically collect and store in our logs about Your visit and usage 
              helps us to analyze our Services to continually improve the value of the Content and Services
              available. Our collected information does not identify a User or Member by personal information,
              and we make no attempt to link other sites or applications with the individuals that use our
              Services. Memo’d does not sell User or Member information to unrelated third parties. Memo’d
              does reserve the right to use the aggregate of User and/or Member information to improve the
              offerings of Memo’d Content and Services. </p>
            </span>
          </section>
          <section ref={model.refs[4]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px]  ml-8">
              <strong className="text-xl">5. INTELLECTUAL PROPERTY; PROPRIETARY RIGHTS.</strong>
              <p className="ml-3"> 5.1  You acknowledge and agree that Memo’d Services may contain proprietary and confidential
               material that is protected by applicable intellectual property rights and other laws.  Furthermore,
               You herein acknowledge and agree that any content which may be contained in any advertisements or
               information presented by and through the Services is protected by copyrights, trademarks, patents,
               or other proprietary rights and laws.  Therefore, except for that which is expressly permitted by
               applicable law or as authorized by Memo’d or such applicable licensor, You agree not to alter,
               modify, lease, rent, loan, sell distribute, transmit, broadcast, publicly perform and/or create
               any plagiaristic works which are based on the Services, in part or in whole.</p>
            
              <p className="ml-3">5.2  Pursuant to this Agreement, Memo’d grants to You a personal, limited non-transferable,
               and non-exclusive right to access and use the Services solely for your personal,
               non-commercial use. Memo’d reserves all rights not expressly granted to You.
               You shall not allow any third party to duplicate, alter, modify,
               create or plagiarize work from, reverse engineer, reverse assemble
               or otherwise make an attempt to locate or discern any Services; or sell,
               assign, sublicense, grant a security interest in, and/or otherwise transfer
               any such right in the Services.  Furthermore, You agree not to alter or change 
               the Services in any manner, nature, or form, and as such, You will not use any 
               modified versions of the Services, including and without limitation, for the 
               purpose of obtaining unauthorized access to the Services.  You also agree not to
               access or attempt to access the Services through any means other than through the
               interface provided by Memo’d for accessing the Services.</p>

              <p className="ml-3">5.3  The content Memo’d provides to You on or through the Services,
               including without limitation, any text, graphics, photos, software,
               and interactive features, may be protected by copyright or other intellectual
               property rights and owned by Memo’d or its third party licensors. You may not
               copy, reproduce, upload, republish, broadcast, transmit, retransmit, post,
               modify, create derivative works of, publicly perform, publicly display,
               use for commercial purpose, or distribute any materials from the Services
               without prior express written permission of the owner of such material or
               as permitted by the Service’s intended functionalities. Your use of the
               Services must be in compliance with applicable law.</p>
          </span>
          </section>
          <section ref={model.refs[5]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px] ml-8">
              <strong className="text-xl">6. USER CONTENT</strong>
              <p className="ml-3"><span className="underline">6.1  User Content.</span>  Memo’d offers Users and Members the ability to submit,
               upload, post, or transmit Content to or through the Services, including,
               without limitation, text, comments, and other works subject to protection
               under the laws of the United States or any other jurisdiction
               ("User Content" or "Posted Content"). Memo’d reserves the right to remove,
               disallow, block, or delete any User Content in its sole discretion.
               Memo’d does not guarantee the accuracy, integrity, appropriateness,
               availability, or quality of any User Content, and under no circumstances
               will Memo’d be liable in any way for any User Content. </p>
              
              <p className="ml-3"><span className="underline">6.2  Licenses to User Content.</span> You hereby grant Memo’d an unrestricted,
               assignable, sublicensable, revocable, royalty-free license throughout
               the universe to reproduce, distribute, publicly display, communicate
               to the public, make available, create derivative works from, retransmit,
               and otherwise exploit and use all or any part of all User Content You 
               provide to or through the Service by any means and through any media and
               formats now known or hereafter developed, for the purposes of (i)
               advertising, marketing, and promoting Memo’d and the Service; (ii)
               displaying and sharing Your User Content to other Users of the Service;
               and (iii) providing the Service as authorized by our Policies.
               You further grant Memo’d a royalty-free license to use Your username,
               image, voice, and likeness to identify You as the source of any of 
               Your User Content. Any User Content provided by You to or through the
               Service or transmitted to Memo’d will be considered non-confidential
               and non-proprietary, and treated as such by Memo’d, and may be used 
               by Memo’d in accordance with our Policies without notice to You and 
               without any liability to Memo’d.</p>
              
              <div className="ml-3 flex flex-col gap-[18px]">
                <span className="flex gap-1">6.3<p className="underline">Rights to Content You Post.</p> You represent and warrant that:</span>
                <p className="ml-3">i.  You own the User Content provided by You on or through the Services, or otherwise
                  have the right to grant the license set forth in this Agreement;</p>
                <p className="ml-3"> ii. the posting and use of Your User Content on or through the Services does not
                  violate the privacy rights, publicity rights, copyrights, contract rights, 
                  intellectual property rights, or any other rights of any person;</p>
                <p className="ml-3">iii. the posting or use of Your User Content on or through the Services will
                     not require us to obtain any further licenses from or pay any royalties, fees,
                  compensation, or other amounts or provide any attribution to any third parties; and</p>
                <p className="ml-3">iv. the posting or use of Your User Content on or through the Services does not
                  result in a breach of contract between You and any third party.</p>
              </div>
              <span className="ml-3 flex flex-col gap-[18px]">
                <strong>
                  6.4 <span className="underline">Objectionable Content.</span> You agree not to engage in any activity,
                   provide any User Content to the Services, or register or use a username,
                    which is or includes material that is or could be interpreted to be:
                </strong>
                <p className="ml-3">i.  offensive, abusive, defamatory, pornographic, threatening, obscene, hateful, 
                  infringing, libelous, unlawful, vulgar, violent, or promotes, advocates, or incites violence, 
                  bigotry, discrimination, hatred, intolerance, or racism;</p>
                <p className="ml-3">ii. intended to or does harass or bully other Users;</p>
                <p className="ml-3">iii. inaccurate, or otherwise fraudulent, false, deceptive, or misleading;</p>
                <p className="ml-3">iv. in violation of any applicable laws, including, but not limited to, laws related to speech;</p>
                <p className="ml-3">v. illegal, or intended to promote or commit an illegal act of any kind, including violations of intellectual property rights, privacy rights, or proprietary rights of Memo’d or a third party, or would violate any agreement to which You are a party;</p> 
                <p className="ml-3">vi. exposing confidential or proprietary information of a third party or personal information about Yourself that it not intended to be publicly broadcasted, including, but not limited to, passwords, private information such as emails, messages, or photos which the owner has not given You permission to publish, and government classified information;</p> 
                <p className="ml-3"> vii.  impersonating or misrepresenting Your affiliation with Memo’d, another User,
                  person, or entity;</p> 
                <p className="ml-3">  viii.  involving the transmission of unsolicited mass mailings or other forms of spam,
                  junk mail, chain letters, or similar;</p>
                <p className="ml-3"> ix.  unauthorized commercial or sales activities;</p>
                <p className="ml-3"> x.  unauthorized linking to, referencing, or otherwise promoting commercial 
                  products or services, except as expressly authorized by Memo’d;</p> 
                <p className="ml-3"> xi. interfering with or in any way disrupting the Memo’d Services;</p>
                <p className="ml-3"> xii.  conflicting with any Memo’d Policies or any other terms or policies applicable
                  to Your use of any of the Services; or</p> 
                <p className="ml-3"> xiii.    removed from any of our Services due to a breach of our Policies, including
                     content created or repurposed to reconstitute or serve the same objective as previously
                  removed User Content.</p>
                <p className="ml-3">
                  The posting or use of any Objectionable Content may subject You to third party claims
                  and none of the rights granted to you in this Terms of Service or any other Memo’d
                  Policy may be raised as a defense against such third party claims. If You encounter any
                  Objectionable Content on the Services, please immediately email <a className="text-memod-green-base hover:underline" href="mailto:support@memod.com">support@memod.com.</a>
                  Memo’d may, in its sole discretion, take any actions it deems necessary and/or appropriate
                  against any User who posts or uses Objectionable Content on the Services.
                </p>
              </span>
            </span>
          </section>
          <section ref={model.refs[6]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px] ml-8">
              <strong className="text-xl">7. COPYRIGHT POLICY</strong>
              <p className="ml-3">
                If You believe that any User Content or Content provided by Memo’d
                infringes copyright rights, please see our <a className="text-memod-green-base hover:underline" href="https://memod.com/legal/copyright-policy">Memo’d Copyright Policy.</a>
              </p>
            </span>
          </section>
          <section ref={model.refs[7]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px] ml-8">
              <strong className="text-xl">8. PRIVACY POLICY</strong>
              <p className="ml-3">
                Your registration data and personal information are strictly protected by Memo’d’s
                online Privacy Policy (see the full Privacy Policy at <a className="text-memod-green-base hover:underline" href="https://memod.com/legal/copyright-policy">https://memod.com/legal/copyright-policy</a>),
                the terms of which are incorporated herein. Please review our Privacy Policy to understand our
                practices.
              </p>
            </span>
          </section>
          <section ref={model.refs[8]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px] ml-8">
              <strong className="text-xl">9.ACCOUNT, USERNAME, PASSWORD AND SECURITY</strong>
              <p className="ml-3">
                9.1  When You set up an account, You are the sole authorized user of Your account.
                  You shall be responsible for maintaining the secrecy and confidentiality of Your
                  password and for all activities that transpire on or within Your account.  It is
                  Your responsibility for any act or omission of any user(s) that access Your account
                  information that, if undertaken by You, would be deemed a violation of this Terms 
                  of Service.  It shall be Your responsibility to notify Memo’d immediately if You
                  notice any unauthorized access or use of Your account or password or any other 
                  breach of security.  Memo’d shall not be held liable for any loss and/or damage 
                  arising from any failure to comply with this section of the Terms of Service.
              </p>
              <span className="flex flex-col gap-[18px] ml-3">
                <strong>
                  9.2  Memo’d herein reserves the right to access,
                   preserve and/or disclose User or Member account
                   information and/or content if it is requested 
                   to do so by law or believes in good faith that 
                   any such action is reasonably necessary for:
                </strong>
                <p className="ml-3">
                  a)    compliance with any legal process;
                </p>
                <p className="ml-3">
                  b)    enforcement of the Terms of Service;
                </p>
                <p className="ml-3">
                  c)    responding to any claim that any content is in violation of the rights of any third party;
                </p>
                <p className="ml-3">
                  d)    responding to requests for customer service; or
                </p>
                 <p className="ml-3">
                  e)    protecting the rights, property, or the personal safety of Memo’d,
                   its Members, or its Users, including members of the general public.
                </p>
              </span>
            </span>
          </section>
          <section ref={model.refs[9]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px] ml-8">
              <strong className="text-xl">10. USE AND STORAGE GENERAL PRACTICES</strong>
              <p className="ml-3">You acknowledge that Memo’d may set up any such practices and/or limits regarding the use of our Services,
               the maximum disk space allowable that shall be allocated on Memo’d servers on the User or Member’s behalf,
               and/or the maximum number of times and/or duration that any User or Member may access our Services in a
               given period of time.  In addition, You also agree that Memo’d has absolutely no responsibility or liability
               for the removal or failure to maintain storage of any library lists or Content maintained or transmitted by
               our Services.  Memo’d reserves the right to modify, alter, and/or update these general practices at our discretion. </p>
            </span>
          </section>
          <section ref={model.refs[10]} className="flex flex-col gap-5  text-white">
            <span className="flex flex-col gap-[18px] ml-8">
              <strong className="text-xl">11. CANCELLATION; TERMINATION; REFUNDS</strong>
              <p className="ml-3">
                 11.1  You may cancel or terminate Your account, associated email address,
                 and/or access to our Services, by submitting a cancellation request to 
                 [support@memod.com] or by following the cancellation instructions provided 
                 on the appropriate App or Site.  Notwithstanding the foregoing, if you have 
                 purchased a Subscription Plan through a third party, Your subscription is also 
                 subject to the terms of Your agreement with that third party (in addition to these 
                 Terms of Service) and to cancel such subscription, you must cancel directly with that 
                 third party.
              </p>
              <p className="ml-3">
                  11.2  If You cancel Your account or access to any Services,
                  You will not receive a refund of any fees already paid.
                  In the event of a cancellation of Your subscription,
                  cancellation will be effective at the end of the current 
                  subscription period and You will have continued access to 
                  Your subscription for the remainder of that period. 
              </p>
              <p className="ml-3">11.3  You agree that Memo’d may, without any prior written notice, immediately suspend,
                terminate, discontinue, and/or limit Your account, any email associated with Your account,
                and access to any of our Services.  Any and all terminations, suspensions, discontinuances,
                and/or limitations of access shall be made at Memo’d’s sole discretion, and Memo’d shall not 
                be liable to You or any other third party with regards to the termination of Your account,
                associated email address, and/or access to any Services.</p>
              <p className="ml-3">The cause for such termination, discontinuance, suspension and/or limitation
               of access shall include, but is not limited to:</p>
              <p className="ml-3">a)  any breach or violation of the Terms of Service or any other incorporated
                   agreement, regulation, and/or guideline;</p>
              <p className="ml-3">b)  by way of request from law enforcement or any other governmental agencies;</p>
              <p className="ml-3">c)  the discontinuance, alteration, and/or material modification to our Services, or any part thereof;</p>
              <p className="ml-3">d)  unexpected technical or security issues;</p>
              <p className="ml-3">
                  e)  any extended period of inactivity;
              </p>
              <p className="ml-3">
                  f)  any engagement by You in any fraudulent or illegal activities; and/or
              </p>
              <p className="ml-3">
              g)  the nonpayment of any associated fees that may be owed by You in connection with Your
               Memo’d account Services.
              </p>
              <p className="ml-3">
               11.4  If You have a subscription or have purchased access to certain Services, and Memo’d suspends or discontinues Your subscription or access to such Services, Memo’d may, in its sole discretion, provide You with a credit, refund, discount, or other form of consideration. 
              </p>
              <p className="ml-3">
                11.5 Upon the cancellation or termination of Your Memo’d account, the following may occur:
              </p>
 

              <p className="ml-3">a) The removal of any access to all or part of the Services and related Content offered within Memo’d;</p>

              <p className="ml-3">b) The deletion of Your password and any and all related information, files, and any such Content that may be associated with Your account, or any part thereof;</p>

              <p className="ml-3">c) The barring of any further use of all or part of the Services and related Content.</p>
            
            </span>
          </section>
          <section ref={model.refs[11]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px] ml-8">
              <strong className="text-xl">12. LINKS</strong>
                <p className="ml-3">
                 Either Memo’d or any third parties may provide links to other websites,
                 applications, services, and/or resources through its Site, Apps, and other 
                 content platforms.  Thus, You acknowledge and agree that Memo’d is not responsible
                 for the availability of any such external sites or resources, and as such, we do 
                 not endorse nor are we responsible or liable for any content, products, advertising,
                 or any other materials, on or available from such third party sites or resources.
                 Furthermore, You acknowledge and agree that Memo’d shall not be responsible or 
                 liable, directly or indirectly, for any such damage or loss which may be a result
                 of, caused or allegedly to be caused by or in connection with the use of or the
                 reliance on any such content, products, advertising, or any other materials
                 made available on or through any such website, application, service, and/or
                 resource.
                </p>
            </span>
          </section>
          <section ref={model.refs[12]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px] ml-8">
              <strong className="text-xl">13. INDEMNITY</strong>
                <p className="ml-3">
                   You agree to defend, indemnify, and hold harmless Memo’d,
                   our subsidiaries, affiliates, agents, employees, officers,
                   partners and/or licensors, from and against any and all
                   claims and expenses, including legal fees, arising out
                   of Your use of the Services, including but not limited to,
                   Your violation of any representation or warranty contained
                   in this Agreement. 
                </p>
            </span>
          </section>
          <section ref={model.refs[13]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px] ml-8">
              <strong className="text-xl">14. WARRANTY DISCLAIMERS</strong>
              <p className="ml-3">
                YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT:
              </p>
                <p className="ml-3">
                  a) THE USE OF THE SERVICES IS AT THE SOLE RISK BY YOU.
                   THE SERVICES SHALL BE PROVIDED ON AN “AS-IS” AND/OR “AS AVAILABLE” BASIS.
                   MEMO’D AND OUR SUBSIDIARIES, AFFILIATES, OFFICERS, EMPLOYEES, AGENTS, PARTNERS AND LICENSORS EXPRESSLY DISCLAIM ANY AND ALL WARRANTIES OF ANY KIND WHETHER EXPRESSED OR IMPLIED, INCLUDING, BUT NOT LIMITED TO ANY IMPLIED WARRANTIES OF TITLE, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT.
                </p>
                <p className="ml-3">
                  b) MEMO’D AND OUR SUBSIDIARIES, OFFICERS, EMPLOYEES, AGENTS,
                   PARTNERS AND LICENSORS MAKE NO SUCH WARRANTIES THAT (i) MEMO’D
                   SERVICES WILL MEET YOUR REQUIREMENTS; (ii) MEMO’D SERVICES SHALL
                   BE UNINTERRUPTED, TIMELY, SECURE OR ERROR-FREE; (iii) THAT SUCH 
                   RESULTS WHICH MAY BE OBTAINED FROM THE USE OF MEMO’D SERVICES WILL
                   BE ACCURATE OR RELIABLE; (iv) QUALITY OF ANY CONTENT, SERVICES, INFORMATION,
                   OR OTHER MATERIAL WHICH MAY BE PURCHASED OR OBTAINED BY YOU THROUGH OUR 
                   SERVICES WILL MEET YOUR EXPECTATIONS; AND (v) THAT ANY SUCH ERRORS CONTAINED
                   IN THE SERVICES SHALL BE CORRECTED.
               </p>
               <p className="ml-3">
                  c) ANY CONTENT DOWNLOADED OR OTHERWISE OBTAINED BY WAY OF MEMO’D SERVICES SHALL
                  BE ACCESSED BY YOUR SOLE DISCRETION AND SOLE RISK, AND AS SUCH, YOU SHALL BE 
                  SOLELY RESPONSIBLE FOR, AND HEREBY WAIVE, ANY AND ALL CLAIMS AND CAUSES OF 
                  ACTION WITH RESPECT TO ANY DAMAGE TO YOUR COMPUTER AND/OR INTERNET ACCESS,
                  DOWNLOADING AND/OR DISPLAYING, OR FOR ANY LOSS OF DATA THAT COULD RESULT FROM 
                  THE DOWNLOAD OF ANY SUCH CONTENT.
              </p>
              <p className="ml-3">
                  d) NO ADVICE AND/OR INFORMATION, DESPITE WHETHER WRITTEN OR ORAL,
                  THAT MAY BE OBTAINED BY YOU FROM MEMO’D OR BY WAY OF OR FROM OUR
                   SERVICES SHALL CREATE ANY WARRANTY NOT EXPRESSLY STATED IN THE TERMS OF SERVICE.
               </p>
               <p className="ml-3">
                  e) THE VIEWS EXPRESSED BY THE CREATORS OF THE CONTENT AVAILABLE THROUGH MEMO’D
                   SERVICES ARE THOSE OF THE RESPECTIVE CREATORS AND DO NOT NECESSARILY REPRESENT
                    OR REFLECT THE VIEWS OF MEMO’D.
               </p>
               <p className="ml-3">
                  f) A SMALL PERCENTAGE OF SOME USERS MAY EXPERIENCE SOME DEGREE OF EPILEPTIC
                    SEIZURE WHEN EXPOSED TO CERTAIN LIGHT PATTERNS OR BACKGROUNDS THAT MAY BE
                    CONTAINED ON A COMPUTER SCREEN OR WHILE USING OUR SERVICES.  CERTAIN CONDITIONS
                    MAY INDUCE A PREVIOUSLY UNKNOWN CONDITION OR UNDETECTED EPILEPTIC SYMPTOM 
                    IN USERS WHO HAVE SHOWN NO HISTORY OF ANY PRIOR SEIZURE OR EPILEPSY.  SHOULD YOU,
                    ANYONE YOU KNOW, OR ANYONE IN YOUR FAMILY, HAVE AN EPILEPTIC CONDITION, PLEASE 
                    CONSULT A PHYSICIAN IF YOU EXPERIENCE ANY OF THE FOLLOWING SYMPTOMS WHILE USING 
                    OUR SERVICES: DIZZINESS, LAYERED VISION, EYE OR MUSCLE TWITCHES, LOSS OF AWARENESS, 
                    DISORIENTATION, ANY INVOLUNTARY MOVEMENT, OR CONVULSIONS.
                </p>
            </span>
          </section>
          <section ref={model.refs[14]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px] ml-8">
              <strong className="text-xl">15. LIMITATION OF LIABILITY</strong>
                <p className="ml-3">
                   TO THE MAXIMUM EXTENT PERMITTED BY LAW , YOU EXPLICITLY ACKNOWLEDGE,
                   UNDERSTAND AND AGREE THAT MEMO’D AND OUR SUBSIDIARIES, AFFILIATES, OFFICERS,
                   EMPLOYEES, AGENTS, PARTNERS AND LICENSORS SHALL NOT BE LIABLE TO YOU FOR ANY
                   PUNITIVE, INDIRECT, INCIDENTIAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES,
                   INCLUDING, BUT NOT LIMITED TO, DAMAGES WHICH MAY BE RELATED TO THE LOSS OF ANY
                   PROFITS, GOODWILL, USE, DATA AND/OR OTHER INTANGIBLE LOSSES, EVEN THOUGH WE MAY
                   HAVE BEEN ADVISED OF SUCH POSSIBILITY THAT SAID DAMAGES MAY OCCUR, AND RESULT
                   FROM:
                </p>
                <p className="ml-3">
                  a)    THE USE OR INABILITY TO USE ANY OF THE SERVICES;
                </p>
                <p className="ml-3">
                  b)    THE COST OF PROCURING SUBSTITUTE SERVICES;
                </p>
                <p className="ml-3">
                    c)    UNAUTHORIZED ACCESS TO OR THE ALTERATION OF YOUR TRANSMISSIONS AND/OR DATA;
                </p>
                <p className="ml-3">
                    d)    STATEMENTS OR CONDUCT OF ANY SUCH THIRD PARTY THROUGH THE SERVICES; AND
                </p>
                <p className="ml-3">
                    e)    ANY OTHER MATTER WHICH MAY BE RELATED TO THE SERVICES.
                </p>
 
                      <p className="ml-3">
                        IN NO EVENT SHALL MEMO’D’S AGGREGATE LIABILITY FOR ALL CLAIMS RELATED TO
                        THE SERVICES EXCEED THE GREATER OF ONE HUNDRED DOLLARS ($100.00) OR THE
                        AMOUNTS PAID BY YOU TO MEMO’D FOR THE PAST SIX MONTHS FOR THE SERVICES.
                      </p>

            </span>
          </section>
          <section ref={model.refs[15]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px] ml-8">
              <strong className="text-xl">16. EXCLUSIONS AND LIMITATIONS</strong>
                <p className="ml-3">THERE ARE SOME JURISDICTIONS WHICH DO NOT ALLOW THE EXCLUSION OF CERTAIN
                  WARRANTIES OR THE LIMITATION OF EXCLUSION OF LIABILITY FOR INCIDENTAL OR
                  CONSEQUENTIAL DAMAGES.  THEREFORE, SOME OF THE ABOVE LIMITATIONS OF THE
                  WARRANTY DISCLAIMERS AND LIMITATIONS OF LIABILITY SECTIONS MAY NOT APPLY TO YOU.</p>
            </span>
          </section>
          <section ref={model.refs[16]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px] ml-8">
              <strong className="text-xl">17. RELEASE</strong>
                <p className="ml-3">In the event of a dispute relating to Your access and/or use of the Services,
                 You agree to release Memo’d (and its officers, directors, employees, contractors,
                 advisors, agents, parent subsidiaries, affiliates, co-branders, partners and any
                 other third parties) from claims, demands and damages (actual and consequential)
                 of every kind and nature, known and unknown, suspected or unsuspected,
                 disclosed and undisclosed, arising out of or in any way connected to such
                 dispute.</p>
            </span>
          </section>
          <section ref={model.refs[17]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px] ml-8">
              <strong className="text-xl">18. SPECIAL ADMONITION RELATED TO FINANCIAL MATTERS</strong>
              <p className="ml-3">Should You intend to create or to join any service, receive or request any such news,
               messages, alerts or other information from the Services concerning companies,
               stock quotes, investments or securities, please review the above “Warranty Disclaimers”
               and “Limitations of Liability” sections.  For this particular type of information,
               the phrase “Let the investor beware” is appropriate.  Memo’d’s Content is provided
               primarily for informational purposes, and no Content that shall be provided or 
               included in the Services is intended for trading or investing purposes.  Memo’d and
               our Content Providers shall not be responsible or liable for the accuracy,
               usefulness or availability of any information transmitted and/or made available
               by way of the Services, and shall not be responsible or liable for any trading
               and/or investment decisions based on any such information.</p>
            </span>
          </section>
          <section ref={model.refs[18]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px] ml-8">
              <strong className="text-xl">19. THIRD PARTY BENEFICIARIES</strong>
              <p className="ml-3">You herein acknowledge, understand and agree, unless otherwise expressly provided
                in the Terms of Service, that there shall be no third-party beneficiaries to this Agreement.</p>
              </span>
          </section>
          <section ref={model.refs[19]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px] ml-8">
              <strong className="text-xl">20. NOTICE</strong>
              <p className="ml-3">Memo’d may furnish You with notices, including notices with regards to any changes to the Terms
               of Service, including but not limited to email, regular mail, MMS or SMS, text messaging,
               postings on the Memo’d platforms, or other reasonable means currently known or any which
               may be herein after developed.  Any such notices may not be received if You violate any
               aspects of the Terms of Service by accessing the Services in an unauthorized manner. 
               Your acceptance of this Terms of Service constitutes Your agreement that You are deemed 
               to have received any and all notices that would have been delivered had You accessed the 
               Services in an authorized manner.</p>
            </span>
          </section>
          <section ref={model.refs[20]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px] ml-8">
              <strong className="text-xl">21. DISPUTE RESOLUTION</strong>
              <p className="ml-3">21.1 <span className="underline"> Arbitration.</span>  You and Memo’d agree that any dispute, claim or controversy arising out of or relating to this Agreement, Your use of the Services, or Your relationship with Memo’d will be settled by binding arbitration, except that each party retains the right to seek injunctive or other equitable relief in a court of competent jurisdiction to prevent the actual or threatened infringement, misappropriation, or violation of a party’s copyrights, trademarks, trade secrets, patents, or other intellectual property rights. You acknowledge and agree that You and Memo’d each are waiving the right to a trial by jury or to participate as a plaintiff as a class member in any class action proceeding. Further, unless You and Memo’d agree otherwise in writing, the arbitrator may not consolidate more than one person’s claims and may not preside over any form class action proceeding.  If this specific paragraph is held unenforceable, then the entirety of this “Dispute Resolution” section will be deemed void.  Except as provided in the preceding sentence, this “Dispute Resolution” section will survive any termination of the Agreement.</p>
              <p className="ml-3">21.2 <span className="underline"> Arbitration Rules and Governing Law.</span>  The arbitration will be administered by the American Arbitration Association (“AAA”) in accordance with the Commercial Arbitration Rules and the Supplementary Procedures for Consumer Related Disputes (the “AAA Rules”) then in effect, except as modified by this “Dispute Resolution” section.  The AAA Rules are available at <a className="text-blue-700 hover:underline" href="http://www.adr.org ">http://www.adr.org </a>or by calling the AAA at 1-800-778-7879.  The Federal Arbitration Act will govern the interpretation of this section.</p>
              <p className="ml-3">21.3 <span className="underline"> Arbitration Process.</span>  A party who desires to initiate the arbitration must provide the other party with a written Demand for Arbitration as specified in the AAA Rules.  The arbitrator will be either a retired judge or an attorney licensed to practice law in the state of California and will be selected by the parties from the AAA’s roster of consumer dispute arbitrators.  If the parties are unable to agree upon an arbitrator within 7 days of delivery of the Demand for Arbitration, then the AAA will appoint the arbitrator in accordance with AAA Rules.</p>
              <p className="ml-3">21.4 <span className="underline"> Arbitration Location and Procedure.</span>  Unless You and Memo’d agree otherwise, the arbitration will be conducted in San Francisco, California.  If Your claim does not exceed $10,000, then the arbitration will be conducted solely on the basis of documents You and Memo’d submit to the arbitrator, unless you request a hearing and the arbitrator then determines that a hearing is necessary.  If Your claim exceeds $10,000, Your right to a hearing will be determined by AAA Rules.  Subject to AAA Rules, the arbitrator will have the discretion to direct a reasonable exchange of information by the parties, consistent with the expedited nature of the arbitration.</p>
              <p className="ml-3">21.5 <span className="underline"> Arbitrator’s Decision.</span> The arbitrator will render an award within the timeframe specified in the AAA Rules. The arbitrator’s decision will include the essential findings and conclusions upon which the arbitrator based the award.  Judgment on the arbitration may be entered in any court having jurisdiction thereof.  Any award of damages by an arbitrator must be consistent with the “Warranty Disclaimers” and “Limitations of Liability” sections above.  The arbitrator may award declaratory or injunctive relief in favor of the claimant only to the extent necessary to provide relief warranted by the claimant’s individual claim.</p>
              <p className="ml-3">21.6 <span className="underline">  Arbitration Fees.</span> Your responsibility to pay any AAA filing, administrative and arbitrator fees will be as set forth in the AAA Rules.</p>
            </span>
          </section>
          <section ref={model.refs[21]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px] ml-8">
              <strong className="text-xl">22. STATUTE OF LIMITATIONS</strong>
              <p className="ml-3">You acknowledge, understand and agree that regardless of any statute or law to the contrary,
               any claim or action arising out of or related to the use of the Services or this Agreement must 
               be filed within four (4) years after said claim or cause of action arose or shall be forever 
               barred.</p>
            </span>
          </section>
          <section ref={model.refs[22]} className="flex flex-col gap-5 text-white">
            <span className="flex flex-col gap-[18px] ml-8">
              <strong className="text-xl">23.GENERAL INFORMATION</strong>
              <p className="ml-3">23.1<span className="underline"> Entire Agreement.</span>  This Terms of Service, including the Memo’d End-User License Agreement, the Memo’d Privacy Policy, Core Program Terms of Use, Content Monetization Terms of Use, Tipping Policy, and any other terms and conditions and policies which are incorporated herein or might accompany the applicable Service, constitute the entire agreement between You and Memo’d and shall govern the use of the Services, superseding any prior agreement between You and Memo’d with respect to the Services.  You may also be subject to additional terms and conditions that may apply when You use or purchase certain other Memo’d Services, affiliate Services, third-party content, or third-party software.</p>
              <p className="ml-3">23.2<span className="underline"> Choice of Law; Venue.</span>  These Terms of Service shall be governed by and construed in accordance with the laws of the state of California without regard to its conflict of law provisions.  To the extent that any lawsuit is permitted under this Agreement, You and Memo’d hereby expressly consent to the personal and exclusive jurisdiction and venue of the state and federal courts located in the City and County of San Francisco, California, and waive any objection as to inconvenient forum.</p>
              <p className="ml-3">23.3<span className="underline"> Waiver; Severability.</span>  At any time, should Memo’d fail to exercise or enforce any right of provision of the Terms of Service, such failure shall not constitute a waiver of such right or provision.  If any provision of this Terms of Service is found by a court of competent jurisdiction to be invalid, the parties nevertheless agree that the court should endeavor to give effect to the parties’ intentions as reflected in the provision, and the other provisions of the Terms of Service remain in full force and effect.</p>
              <p className="ml-3">23.4<span className="underline"> No Right of Survivorship; Non-Transferability.</span>  You acknowledge and agree that Your account is non-transferable and any rights to Your account and/or contents within Your account shall terminate upon Your death. </p>
              <p className="ml-3">23.5<span className="underline"> Changes to Terms of Service.</span>  Memo’d may, from time to time, change these Terms of Service. Such revisions shall be effective immediately.  Your continued use of the Services indicates Your acceptance of such changes, and as such, Your frequent review of this Agreement and Policies currently in effect.  Should You not agree to any updated, revised or modified terms, You must stop using the provided Services forthwith.</p>
              <p className="ml-3">23.6<span className="underline"> Assignment.</span>  We may assign our agreement with You to any affiliated company or to any entity that succeeds to all or substantially all of our business or assets related to the applicable Memo’d Services.  Neither these Terms of Service nor any right, obligation, or remedy hereunder is assignable, transferable, delegatable, or sublicensable by You except with our prior written consent, and any attempted assignment, transfer, delegation, or sublicense shall be null and void.   </p>
              <p className="ml-3">23.7<span className="underline"> Electronic Communications.</span>  When You use the Services, or send e-mails, text messages, and other communications from Your computer or mobile device to us, You may be communicating with us electronically.  You consent to receive communications from Memo’d electronically, such as e-mails, texts, mobile push notices, or notices, and messages through the Services, and you can retain copies of these communications for your records.  You agree that all agreements, notices, disclosures, and other communications that we provide to You electronically satisfy any legal requirement that such communications be in writing.</p>
              <p className="ml-3"><span></span>Last updated: February 2023</p>
            </span>
          </section>
        </article>
      </main>
    </LegalLayout>
  );
}
